import { secureGet } from "config/encryption_decryption/get_post_encryptDecrypt";
import { axiosClient } from "../api";

export const checkAndupdateSurveyStatusApi = async ( UID: any, SID: string, VID: string, hmacValue: any, currentUrl: string, sessionId: string, type: string) => {
  return secureGet("/api/survey/checkAndUpdateSurveyStatus", { UID, SID, VID, hmacValue, currentUrl, session_id: sessionId, type});
};

export const checkUserProfileStatusApi = async (UID: string) => {
  return axiosClient
    .post("/api/user/getUserProfileStatus", { UID })
    .then((response) => response.data);
};
